import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { Accordion, CheckBox } from '..';
const TreeNode = React.memo((props) => {
    const { nodes = [], isChild, selected, onSelect, id, enableCheckbox, size, } = props;
    const style = useMemo(() => {
        if (isChild) {
            return {
                paddingLeft: '1.5rem',
            };
        }
        else {
            return {
                transition: 'max-height 0.5s ease-in',
            };
        }
    }, [isChild, selected]);
    const [expanded, setExpanded] = useState(false);
    const handleChange = useCallback((open, nodeId) => {
        onSelect?.(nodeId, open);
        if (open) {
            setExpanded(open);
        }
    }, []);
    return (_jsx("div", { style: style, id: id, role: "treeitem", "aria-expanded": expanded, "aria-checked": enableCheckbox && selected, children: nodes.map((node, index) => (_jsx("div", { style: { marginBottom: '0.25rem' }, children: _jsx(Accordion, { title: node.name, disableIcon: !node.nodes?.length, autoSetBodyHeight: false, disableARIA: true, size: size, onChange: open => {
                    if (!enableCheckbox) {
                        handleChange(open, node.id);
                    }
                }, selected: !enableCheckbox && node.selected, animate: false, customContent: enableCheckbox ? (_jsx(CheckBox, { label: node.name || '', noUniqueId: true, id: node.id, focusable: false, onChange: (_, nodeSelected) => handleChange(nodeSelected, node.id), isChecked: node.selected, noHoverStyle: true, autoHeight: true, size: size })) : null, children: Boolean(node.nodes?.length) && (_jsx("div", { style: {
                        margin: '0.5rem 0',
                    }, role: "tree", children: _jsx(TreeNode, { nodes: node.nodes || [], name: node.name, isChild: true, id: node.id, onSelect: x => onSelect?.(node.id + '/' + x, node.selected), selected: node.selected, enableCheckbox: enableCheckbox, size: size }, node.id) })) }) }, index))) }));
});
TreeNode.displayName = 'TreeNode';
export { TreeNode };
